import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';

export default function JobModeSelector({ jobMode, onJobModeChange }) {
  return (
    // 新增 mt: -3 (大約是往上提 24px)，你可以根據實際視覺效果微調這個數字 (-2, -3, -4)
    <Box sx={{ display: 'flex', justifyContent: 'flex-start', mt: -3, mb: 1, pl: 2 }}>
      <RadioGroup
        row
        value={jobMode}
        onChange={(e) => onJobModeChange(e.target.value)}
      >
        <FormControlLabel value="bigJob" control={<Radio />} label="大非農" />
        <FormControlLabel value="smallJob" control={<Radio />} label="小非農(ADP)" />
      </RadioGroup>
    </Box>
  );
}